/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EnumDto } from './EnumDto';
export type SystemConfigurationDto = {
    /**
     * System configuration identifier. Type: 'UUID'
     */
    id: string;
    /**
     * Eshop multi localization
     */
    eshopMultiLocalizationEnabled: boolean;
    /**
     * Card application enabled upload attachments.
     */
    cardApplicationFilesUploadEnabled: boolean;
    /**
     * E-wallet on virtual card.
     */
    virtualCardEWalletEnabled: boolean;
    /**
     * Eshop footer manual.
     */
    eshopFooterManualEnabled: boolean;
    /**
     * SMTP permeability.
     */
    SMTPPermeabilityEnabled: boolean;
    /**
     * Bank card as carrier.
     */
    bankCardAsCarrier: boolean;
    /**
     * Allowed short term tickets.
     */
    allowShortTermTickets: boolean;
    /**
     * Payment gateway.
     */
    paymentGateway: string;
    /**
     * EET localization.
     */
    EETLocalization: string;
    /**
     * Currency.
     */
    currency: string;
    /**
     * Use camera to take customer photo in card application.
     */
    allowCameraInCardApplication: boolean;
    /**
     * Allow card application for free.
     */
    allowFreeCardApplication: boolean;
    /**
     * Eshop payment types.
     */
    eshopAllowedPaymentTypes: Array<EnumDto>;
    /**
     * Counter payment types.
     */
    counterAllowedPaymentTypes: Array<EnumDto>;
    /**
     * Language code of the default locale.
     */
    defaultLanguage: string;
    /**
     * Ticket min valid from.
     */
    ticketMinValidFrom: string;
    /**
     * Show taxes on counter receipt.
     */
    showTaxOnReceipt: boolean;
    /**
     * Region Code.
     */
    haulierTokenKey: string;
    /**
     * Migration from legacy systems. Possible values: "TELSHOP"
     */
    migrationFlags: Array<string>;
    /**
     * Haulier card as carrier.
     */
    haulierCardAsCarrier: boolean;
    /**
     * Haulier card white list as carrier.
     */
    haulierCardWLAsCarrier: boolean;
    /**
     * Virtual card as carrier.
     */
    virtualCardAsCarrier: boolean;
    /**
     * Marketing consent on card.
     */
    marketingConsentCardEnabled: boolean;
    /**
     * Refund reason on cancel ticket.
     */
    refundReasonEnabled: boolean;
    showSimpleCardApplication: boolean;
    addressStreetRequired: boolean;
    addressStreetNumberRequired: boolean;
    addressCityRequired: boolean;
    addressZipCodeRequired: boolean;
    ticketCancellationFinalizationEnabled: boolean;
    priceListUseActualDateInsteadValidFrom: boolean;
    eshopReclamationEnabled: boolean;
    synchronizationWithExternalEnabled: boolean;
    allowIsic: boolean;
    assignCardWithoutAgeRestriction: boolean;
    allowCustomerCardGroup: boolean;
    allowPersistEshopSideMenu: boolean;
    allowBankCardApplicationFromCounter: boolean;
    allowCloseEshopToastOnlyUsingButton: boolean;
    allowUpdateCardValidity: boolean;
    allowFirstCardApplicationWithDiscountProfileForFree: boolean;
    disableDeleteAccountWithActiveTicketsAndEP: boolean;
    allowSetDefaultProfileValidFromByCardValidFrom: boolean;
    /**
     * Allow registration for customers under 15 years. Requires parent verification.
     */
    allowCustomerRegistrationUnder15Years: boolean;
    allowCustomerCreationUnder15Years: boolean;
    allowCustomerProfileApplication: boolean;
    allowTicketCancellation: boolean;
    allowRewardProgram: boolean;
    allowExpressCardProduction: boolean;
    allowExternalCards: boolean;
    allowWhitelists: boolean;
    allowPickupInPostOffice: boolean;
    allowReclamationCards?: boolean;
    allowPaperCards?: boolean;
    allowPersonalDetailsEdit?: boolean;
    allowPersonalDetailsOptional?: boolean;
    allowSmartCardWithoutStructure?: boolean;
    allowCouponAndCardValidToOverlap?: boolean;
    /**
     * Tariff core type.
     */
    tariffCoreType: SystemConfigurationDto.tariffCoreType;
    allowZoneCountPriceList?: boolean;
    allowClearing: boolean;
    customerProfileLimit: number;
    allowOffenses: boolean;
    allowThirdPartyTickets: boolean;
    /**
     * Allow login/registration with google OAuth provider.
     */
    allowGoogleLogin: boolean;
    /**
     * Allow login/registration with facebook OAuth provider.
     */
    allowFacebookLogin: boolean;
};
export namespace SystemConfigurationDto {
    /**
     * Tariff core type.
     */
    export enum tariffCoreType {
        ZONE = 'ZONE',
        RELATIONAL = 'RELATIONAL',
    }
}

